import css from "classnames";
import React from "react";
import styles from "./index.module.css";

interface Props {
  type?: "light" | "normal" | "emphasis" | "heavy" | "note";
}

const Text: React.FC<Props & React.HTMLProps<HTMLSpanElement>> = props => {
  const { children, type = "normal", className, ...rest } = props;
  return (
    <span className={css(className, styles[type])} {...rest}>
      {children}
    </span>
  );
};

export default Text;
